export { default } from "./useLazyRestQuery";
